import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import { enqueueSnackbar } from 'notistack';
import useCreateBankAccount from '../../resources/bankAccounts/create';
import useApplication from '../../resources/applications/read';

const useForm = ({ onDone }) => {
  const {
    mutate: mutateApplication,
    isValidating: isValidatingApplication,
  } = useApplication();

  const onSubmit = (form) => ({
    type: 'MANUAL',
    routing_number: form.routingNumber,
    account_number: form.accountNumber,
    bank_name: form.bankName,
    account_type: form.accountType,
  });

  const onSuccess = async () => {
    enqueueSnackbar('Your bank account was added.', { variant: 'success' });
    await mutateApplication(); // needed for AutoPayTermsAndConditions
    onDone();
  };

  const {
    handleSubmit,
    isSubmitting,
    form,
  } = useSWRMutationForm({
    useMutation: () => useCreateBankAccount({ onSuccess }),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });

  const isLoading = isSubmitting || isValidatingApplication;

  return {
    isLoading,
    handleSubmit,
    form,
  };
};

export default useForm;
